import React, { useState } from 'react'
import { toast } from 'react-toastify'
import PageShell from '../../components/PageShell/PageShell'
import { ContactArt } from '../../components/PageShell/HeroArt'
import './Contact.scss';
import useAxios from '../../helpers/Hooks/useAxios';
import { URLS } from '../../helpers/URLS';

const EMAIL_TO = 'info@workhubmanager.co.in';

const NEXT = [
    { n: '01', title: 'We read it', copy: 'A person, not an autoresponder. Usually within one working day.' },
    { n: '02', title: 'We ask what you run today', copy: 'Team size, how you track hours and leave now, and what keeps breaking.' },
    { n: '03', title: 'We show you the real thing', copy: 'A walkthrough on your own numbers, not a canned demo deck.' },
];

const Contact = () => {
    const { fetchData } = useAxios();

    const [form, setForm] = useState({ name: '', email: '', company: '', message: '' });

    const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const [sending, setSending] = useState(false);

    const submit = async (e) => {
        e.preventDefault();

        if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
            toast.error('Please fill in your name, email and message');
            return;
        }

        if (sending) return;
        setSending(true);

        const resp = await fetchData({
            url: URLS.contactEnquiry,
            method: 'post',
            body: {
                name: form.name.trim(),
                email: form.email.trim(),
                company: form.company.trim(),
                message: form.message.trim(),
            },
        });

        setSending(false);

        if (resp?.success === false) {
            toast.error(resp?.message || 'We could not send your message. Please try again.');
            return;
        }

        toast.success('Thanks — we have your message and will be in touch');
        setForm({ name: '', email: '', company: '', message: '' });
    };

    return (
        <PageShell
            eyebrow="Contact us"
            title="Tell us what your week looks like"
            lede="Questions about the product, pricing, or moving your team across from spreadsheets — we would rather have the conversation than send you a brochure."
            art={<ContactArt />}
        >
            <section className="pg-sec pg-sec--light">
                <div className="container">
                    <div className="pg-split pg-split--even">
                        {/* form */}
                        <form className="ct-form" onSubmit={submit} noValidate>
                            <h2 className="pg-h3 ct-form-title">Send us a message</h2>

                            <div className="ct-row">
                                <label className="ct-field">
                                    <span>Your name</span>
                                    <input type="text" name="name" value={form.name} onChange={change} placeholder="John David" />
                                </label>
                                <label className="ct-field">
                                    <span>Work email</span>
                                    <input type="email" name="email" value={form.email} onChange={change} placeholder="john@company.com" />
                                </label>
                            </div>

                            <label className="ct-field">
                                <span>Company <i>optional</i></span>
                                <input type="text" name="company" value={form.company} onChange={change} placeholder="Company name" />
                            </label>

                            <label className="ct-field">
                                <span>How can we help?</span>
                                <textarea name="message" rows="5" value={form.message} onChange={change}
                                    placeholder="Team size, what you use today, and what you would like to fix." />
                            </label>

                            <button type="submit" className="pg-btn pg-btn--primary" disabled={sending}>
                                    {sending ? "Sending…" : "Send message"}
                                </button>
                            <p className="ct-note">
                                This opens your email app with the message ready to send, so nothing is
                                stored on this site.
                            </p>
                        </form>

                        {/* details */}
                        <div className="ct-aside">
                            <p className="pg-eyebrow">Reach us directly</p>
                            <h2 className="pg-title pg-title--grad">Or skip the form</h2>

                            <ul className="ct-list">
                                <li>
                                    <span className="ct-label">Email</span>
                                    <a href={`mailto:${EMAIL_TO}`}>{EMAIL_TO}</a>
                                </li>
                                <li>
                                    <span className="ct-label">Phone</span>
                                    <a href="tel:+914046515454">+91 40 4651 5454</a>
                                </li>
                                <li>
                                    <span className="ct-label">Office</span>
                                    Dallas Center, 6th &amp; 7th Floor, 83/1, No A1,<br />
                                    Knowledge City Rd, Rai Durg,<br />
                                    Hyderabad, Telangana 500032
                                </li>
                                <li>
                                    <span className="ct-label">Hours</span>
                                    Monday to Friday, 9:30am &ndash; 6:30pm IST
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="pg-sec pg-sec--wash">
                <div className="container">
                    <header className="pg-head pg-head--center">
                        <p className="pg-eyebrow">What happens next</p>
                        <h2 className="pg-title">No sales sequence, no drip campaign</h2>
                    </header>
                    <ul className="pg-grid pg-grid--3">
                        {NEXT.map((s) => (
                            <li className="pg-card" key={s.n}>
                                <span className="ct-step">{s.n}</span>
                                <h3 className="pg-h3">{s.title}</h3>
                                <p>{s.copy}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        </PageShell>
    )
}

export default Contact
